import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-planning-evaluation-committee',
  templateUrl: './planning-evaluation-committee.component.html',
  styleUrls: ['./planning-evaluation-committee.component.scss']
})
export class PlanningEvaluationCommitteeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
